import React, { useState } from "react";
import SupportService from "../../modules/Admin/services/SupportService";

const C = {
  ink: '#344767', muted: '#8392ab', border: '#e9ecef',
  primary: '#5e72e4', success: '#2dce89',
  bgSoft: '#f8f9fe', shadow: '0 2px 24px rgba(52,71,103,0.09)',
};

const inp = {
  width: '100%', padding: '11px 14px', border: `1.5px solid ${C.border}`,
  borderRadius: 10, fontSize: 14, color: C.ink, boxSizing: 'border-box',
  outline: 'none', background: '#fff', transition: 'border-color .15s',
};

const channels = [
  { icon: 'fas fa-envelope', color: '#5e72e4', label: 'Email', value: 'support@nextfollowup.in' },
  { icon: 'fas fa-comment-dots', color: '#25d366', label: 'WhatsApp', value: '+91 98765 43210' },
  { icon: 'fas fa-clock', color: '#fb6340', label: 'Response Time', value: 'Within 2–4 hours' },
];

const faqs = [
  { q: 'How do I add a new lead?', a: 'Go to Leads → Add Lead, fill in the contact details, and assign it to an employee.' },
  { q: 'Can I import leads from Excel?', a: 'Yes — use the Excel Import option from the Leads page to bulk-upload leads from a .xlsx file.' },
  { q: 'How do follow-up reminders work?', a: 'Set a follow-up date on any assigned lead. The system will flag it as overdue in the notification bell and Pending Follow-Ups page.' },
  { q: 'How do I connect Facebook Lead Ads?', a: 'Super Admin → Clients → open your agency → Integration tab → Facebook Lead Ads section.' },
];

export default function SupportForm() {
  const [emailData, setEmailData] = useState({ fromEmail: '', subject: '', body: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  const handleChange = (e) => setEmailData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      await SupportService.sendEmail(emailData);
      setSent(true);
      setEmailData({ fromEmail: '', subject: '', body: '' });
    } catch (err) {
      setError('Something went wrong. Please try again or email us directly.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ background: C.bgSoft, minHeight: '100vh', fontFamily: 'inherit' }}>

      {/* ── hero ── */}
      <div style={{ background: 'linear-gradient(135deg,#344767 0%,#21243d 100%)', padding: '52px 24px 72px', textAlign: 'center' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 66, height: 66, borderRadius: 18, background: 'rgba(255,255,255,0.12)', fontSize: 28, color: '#fff', marginBottom: 18 }}>
          <i className="fas fa-headset" />
        </div>
        <h1 style={{ margin: '0 0 12px', fontSize: 32, fontWeight: 800, color: '#fff' }}>Quick Support</h1>
        <p style={{ margin: '0 auto', maxWidth: 480, fontSize: 15, color: 'rgba(255,255,255,0.72)', lineHeight: 1.6 }}>
          Send us a message and our team will get back to you as soon as possible.
        </p>
      </div>

      <div style={{ maxWidth: 960, margin: '0 auto', padding: '0 20px 60px' }}>

        {/* ── contact channel chips ── */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, marginTop: -28, marginBottom: 36, justifyContent: 'center' }}>
          {channels.map(({ icon, color, label, value }) => (
            <div key={label} style={{ background: '#fff', borderRadius: 14, boxShadow: C.shadow, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 12, minWidth: 180 }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color, flexShrink: 0 }}>
                <i className={icon} />
              </div>
              <div>
                <p style={{ margin: 0, fontSize: 11, color: C.muted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</p>
                <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: C.ink }}>{value}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(420px,1fr))', gap: 24 }}>

          {/* ── contact form ── */}
          <div style={{ background: '#fff', borderRadius: 20, boxShadow: C.shadow, overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg,#5e72e4,#825ee4)', padding: '22px 28px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <i className="fas fa-paper-plane" style={{ color: '#fff', fontSize: 18 }} />
              <span style={{ fontWeight: 800, fontSize: 16, color: '#fff' }}>Send a Message</span>
            </div>
            <div style={{ padding: '28px 28px 32px' }}>

              {sent ? (
                <div style={{ textAlign: 'center', padding: '32px 0' }}>
                  <div style={{ width: 64, height: 64, borderRadius: 18, background: `${C.success}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, color: C.success, margin: '0 auto 16px' }}>
                    <i className="fas fa-check-circle" />
                  </div>
                  <h3 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 800, color: C.ink }}>Message Sent!</h3>
                  <p style={{ margin: '0 0 20px', color: C.muted, fontSize: 14 }}>We'll get back to you within 2–4 hours.</p>
                  <button onClick={() => setSent(false)}
                    style={{ background: 'linear-gradient(135deg,#5e72e4,#825ee4)', border: 'none', borderRadius: 10, padding: '10px 22px', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Your Email *</label>
                    <input name="fromEmail" type="email" required value={emailData.fromEmail} onChange={handleChange}
                      placeholder="you@example.com" style={inp} onFocus={(e) => e.target.style.borderColor = C.primary} onBlur={(e) => e.target.style.borderColor = C.border} />
                  </div>
                  <div style={{ marginBottom: 18 }}>
                    <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Subject *</label>
                    <input name="subject" type="text" required value={emailData.subject} onChange={handleChange}
                      placeholder="How can we help?" style={inp} onFocus={(e) => e.target.style.borderColor = C.primary} onBlur={(e) => e.target.style.borderColor = C.border} />
                  </div>
                  <div style={{ marginBottom: 22 }}>
                    <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>Message *</label>
                    <textarea name="body" required rows={5} value={emailData.body} onChange={handleChange}
                      placeholder="Describe your issue or question in detail…"
                      style={{ ...inp, resize: 'vertical', lineHeight: 1.6 }}
                      onFocus={(e) => e.target.style.borderColor = C.primary} onBlur={(e) => e.target.style.borderColor = C.border} />
                  </div>
                  {error && (
                    <p style={{ margin: '0 0 16px', padding: '10px 14px', background: '#fff0f3', borderRadius: 8, color: '#f5365c', fontSize: 13, fontWeight: 600 }}>
                      <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />{error}
                    </p>
                  )}
                  <button type="submit" disabled={sending}
                    style={{ width: '100%', background: sending ? '#a0acf5' : 'linear-gradient(135deg,#5e72e4,#825ee4)', border: 'none', borderRadius: 11, padding: '13px', color: '#fff', fontWeight: 800, fontSize: 14, cursor: sending ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, boxShadow: '0 4px 14px rgba(94,114,228,0.35)' }}>
                    <i className={`fas ${sending ? 'fa-spinner fa-spin' : 'fa-paper-plane'}`} />
                    {sending ? 'Sending…' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* ── FAQ ── */}
          <div style={{ background: '#fff', borderRadius: 20, boxShadow: C.shadow, overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg,#344767,#21243d)', padding: '22px 28px', display: 'flex', alignItems: 'center', gap: 12 }}>
              <i className="fas fa-question-circle" style={{ color: '#fff', fontSize: 18 }} />
              <span style={{ fontWeight: 800, fontSize: 16, color: '#fff' }}>Common Questions</span>
            </div>
            <div style={{ padding: '16px 0' }}>
              {faqs.map(({ q, a }, i) => (
                <div key={i} style={{ borderBottom: i < faqs.length - 1 ? `1px solid ${C.border}` : 'none' }}>
                  <button type="button" onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    style={{ width: '100%', background: 'none', border: 'none', padding: '16px 24px', textAlign: 'left', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: C.ink }}>{q}</span>
                    <i className={`fas fa-chevron-${openFaq === i ? 'up' : 'down'}`} style={{ color: C.muted, fontSize: 12, flexShrink: 0 }} />
                  </button>
                  {openFaq === i && (
                    <div style={{ padding: '0 24px 16px' }}>
                      <p style={{ margin: 0, fontSize: 13, color: C.muted, lineHeight: 1.7, background: C.bgSoft, borderRadius: 10, padding: '12px 14px' }}>{a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
